import React from "react";
import { useTranslation } from 'react-i18next';

const Switch = props => {
  const { t } = useTranslation("switch");
  return (
    <div className={props.width <= 700 ? "tabs_controls_R": ""}>
      <div className="switch_select_area">
        <span className={!props.isGifts ? "see_rooles" : null}></span>
        <button
          onClick={() => props.setGifts(true)}
          className={props.isGifts ? "if_switched_color" : null}
        >
          { props.showConditionsFirst ? t('УСЛОВИЯ ИГРЫ') : t('ПОДАРКИ') }
        </button>
        <button
          onClick={() => props.setGifts(false)}
          className={!props.isGifts ? "if_switched_color" : null}
          data-tut="reactour__conditions"

        >
          { props.showConditionsFirst ? t('ПОДАРКИ') : t('УСЛОВИЯ ИГРЫ') }
        </button>
      </div>
    </div>
  );
};

export default Switch;
